import { PaginatedResponse } from "../../types/api";
import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import { HubResponse, PaginatedHubResponse } from "./types";
import { getErrorMessage } from "../errors";
import { IRefStoresService } from "./IRefStoresService";

export class RefStoresService implements IRefStoresService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getAll(
    page: number = 0,
    size: number = 10,
  ): Promise<PaginatedResponse<HubResponse>> {
    try {
      const queryParams = new URLSearchParams();
      if (page !== undefined && page !== null) {
        queryParams.append("page", page.toString());
      }
      if (size !== undefined && size !== null) {
        queryParams.append("size", size.toString());
      }

      const queryString = queryParams.toString();
      const endpoint = `/refStores${queryString ? `?${queryString}` : ""}`;

      return await this.httpClient.get<PaginatedResponse<HubResponse>>(
        endpoint,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar as lojas. Atualize a página e confirme a loja selecionada.",
      );
      throw new Error(errorMessage);
    }
  }

  async getAllHubs(): Promise<PaginatedHubResponse> {
    try {
      return await this.httpClient.get<PaginatedHubResponse>("/refStores/all");
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar as lojas. Atualize a página e confirme a loja selecionada.",
      );
      throw new Error(errorMessage);
    }
  }

  getStoreByHubCode(
    hubCode: string,
    signal?: AbortSignal,
  ): Promise<HubResponse> {
    return this.httpClient.get<HubResponse>(
      `/refStores/byHubsCode/${hubCode}`,
      signal ? { signal } : {},
    );
  }

  getStoreById(id: number, signal?: AbortSignal): Promise<HubResponse> {
    return this.httpClient.get<HubResponse>(
      `/refStores/${id}`,
      signal ? { signal } : {},
    );
  }
}
